import { SYSTEM_MAINTENANCE_NOTICE } from '@belong/common';
import { MaintenanceNoticeToast } from '@belong/ui';
import { useFeatureFlag } from 'src/features/feature-flags/hooks';

export function SystemNoticeToast() {
  const { isEnabled } = useFeatureFlag('consumer-communication-banner');

  if (!isEnabled) {
    return null;
  }

  return <MaintenanceNoticeToast {...SYSTEM_MAINTENANCE_NOTICE} />;
}
